import React from "react";
import Navbar from "../../component/Navbar";
import Footer from "../../component/Footer";
import { Link } from "react-router-dom";
import { useState } from "react";

const Lonely = () => {
  const [comment, setComment] = useState("");
  const handleSubmit = async () => {
    try {
      const COMMENTENDPOINT =
        "https://thrive-mqy3.onrender.com/v1/docs/#/comments/post_comment";
      const commentDetails = {
        //location: 'Lonely',

        comment,
      };
      // console.log(loginDetails);
      const usersDetail = {
        method: "POST",
        body: JSON.stringify(commentDetails),
        headers: { "Content-Type": "application/json" },
      };

      const response = await fetch(COMMENTENDPOINT, usersDetail);
      //console.log(response);
      const data = await response.json();
      // setUserInfo(data.user);
      console.log(data);
    } catch (error) {
      console.log("something went wrong" + error);
    }
  };

  return (
    <div>
      <Navbar />
      <div className="text-black ml-20 mt-2">
        <Link to="/videomain">
          <button className="flex gap-1 px-4 py-2 rounded-xl w-fit">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-4 h-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18"
              />
            </svg>
            Back
          </button>
        </Link>
      </div>
      <div>
        <h1 className="font-bold text-3xl py-5 text-center text-[#2A3D19]">
          WHY SO LONELY?
        </h1>
        <div className="flex flex-col lg:items-center justify-center px-5 bg-[#DCAE96] mr-20 ml-20 mb-2">
          <div className="w-full lg:w-1/2 flex py-5">
            <video
              controls
              src="https://res.cloudinary.com/dzqx4v0al/video/upload/v1700576664/sad-boy_tw8ml1.mp4"
            />
          </div>
          <div className="w-full lg:w-1/2 lg:px-2 lg:py-1 lg:mr-8 lg:ml-8 lg:mt-6 lg:mb-8">
            <p className="text-[#2A3D19] text-l">
              Remember, loneliness is a transient emotion- it ebbs and flows.
              Embrace solitude as a chance to reconnect with yourself and
              explore the depths of your thoughts and dreams. Ultimately, by
              fostering a sense of belonging within, you can navigate the
              journey from “why so lonely?” “to how can I create connections?”
              -unveiling a path to a more fulfilling and connected existence
            </p>
          </div>
          <div className="flex flex-col lg:flex-row lg:gap-16 gap-4 px-4 py-5 justify-center">
            <Link
              download
              to="https://res.cloudinary.com/dzqx4v0al/video/upload/v1700576664/sad-boy_tw8ml1.mp4"
            >
              <button className="flex gap-4 bg-[#2A3D19] text-white hover:bg-green-400 px-4 py-3 font-semibold w-full">
                {" "}
                DOWNLOAD{" "}
                <img
                  src="https://res.cloudinary.com/dzqx4v0al/image/upload/v1700576552/download_mdt2bt.png"
                  className="w-[20px]"
                  alt=""
                />
              </button>
            </Link>
          </div>
          <p className="w-1/2 text-center text-[#2A3D19] px-4 py-3 font-semibold border-solid border-2 border-[#2A3D19]">
            {" "}
            COMMENTS{" "}
          </p>
          <div className="flex flex-col w-full lg:w-1/2 mt-4">
            <form className="flex flex-col items-center">
              <textarea
                id="text"
                className="w-full lg:w-full border-solid border-1 border-[#2A3D19]  px-2 h-[200px]"
                placeholder="Please type your comment here"
                onChange={(e) => setComment(e.target.value)}
                defaultValue={""}
              />
            </form>
          </div>
          <div className="flex flex-row gap-8 py-5">
            <button
              className="bg-[#2A3D19] hover:bg-green-400 text-white px-6 py-3 font-semibold"
              onClick={handleSubmit}
            >
              SUBMIT
            </button>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Lonely;
